import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Button } from '@mui/material';

import ContentBox from './layout/ContentBox';

const EmptySubmissionSectionWarning = ({ onCancel, onContinue }) => (
  <ContentBox
    title={<FormattedMessage id="mysurvey.emptySectionWarning" />}
  >
    <FormattedMessage id="mysurvey.emptySectionWarningText" />
    <div
      style={{ marginTop: 15, marginBottom: 10 }}
    >
      <FormattedMessage id="mysurvey.emptySectionWarningQuestion" />
    </div>
    <div>
      <Button
        variant="contained"
        className="ml3 mt3"
        onClick={onContinue}
        secondary
      >
        <FormattedMessage id="yes" />
      </Button>
      <Button
        variant="contained"
        className="ml3 mt3"
        onClick={onCancel}
        primary="true"
      >
        <FormattedMessage id="no" />
      </Button>
    </div>
  </ContentBox>
);

EmptySubmissionSectionWarning.propTypes = {
  onContinue: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default EmptySubmissionSectionWarning;
